import { CarMaxSharpSansDispBold as o, Lato as a, LatoBold as r } from "./fontFaces.js";
const s = {
  styleOverrides: `
        ${o}
        ${a}
        ${r}
    `
};
export {
  s as default
};
